<template>
  <div class="home-main">
    <section class="hero-section">
      <div class="bg-layer">
        <div class="hero-light-cast"></div>
        
        <div class="hero-bg-group">
          <div class="binance-logo-right main"></div>
          <div class="binance-logo-right reflect"></div>
        </div>

        <div class="deco-dot dd-1"></div>
        <div class="deco-dot dd-2"></div>
        <div class="deco-dot dd-3"></div>
      </div>
      
      <div class="container hero-flex">
        <div class="hero-text">
          <h1 class="main-title" v-html="txt.hero.title"></h1>
          <p class="sub-desc">{{ txt.hero.desc }}</p>
          <div class="hero-btns">
            <button class="btn-primary" @click="openNodePurchase">{{ txt.hero.buy_nodes }}</button>
            <button class="btn-outline" @click="$emit('switch-view', 'whitepaper')">{{ txt.hero.btn2 }}</button>
          </div>
          <div class="stats-bar">
            <div class="s-group"><div class="s-val">$48.2M+</div><div class="s-lbl">{{ txt.common.totalValueLocked }}</div></div>
            <div class="s-group"><div class="s-val">128K+</div><div class="s-lbl">{{ txt.hero.judgments }}</div></div>
          </div>
        </div>
      </div>
    </section>

    <section class="market-section">
      <div class="container">
        <div class="grid-header"><span class="m-head">🔥 {{ txt.markets.title }} (30 {{ txt.common.activeMarkets }})</span></div>
        <div class="markets-grid-30">
          <div class="market-card" v-for="(m, index) in marketList" :key="index">
            <div class="mc-top">
              <span class="badge" :style="{color: m.color, background: m.color+'15'}">#{{ m.id }}</span>
              <span class="vol">{{ txt.common.volume }}: {{ m.vol }}</span>
            </div>
            <h4 class="mc-title">{{ m.title }}</h4>
            <div class="mc-prob">
              <div class="prob-bar"><div class="fill" :style="{width: m.prob+'%', background: m.color}"></div></div>
              <span>{{ txt.common.yes }}: {{ m.prob }}%</span>
            </div>
            <button class="trade-btn" :style="{background: m.color}" @click="$emit('open-market', m)">{{ txt.markets.trade }}</button>
          </div>
        </div>
        <div class="load-more-wrap">
          <button class="load-more-btn">{{ txt.common.viewAllMarkets }}</button>
        </div>
      </div>
    </section>

    <section class="infra-section-redesigned">
      <div class="ambient-glow"></div>

      <div class="container split-layout-pro">
        <div class="left-visual-anchor">
          <div class="genesis-card-lite">
            <div class="gc-icon-box">🚀</div>
            <div class="gc-info-lite">
              <div class="gc-title-lite">{{ txt.genesis.title }} <span class="live-tag">LIVE</span></div>
              <div class="gc-desc-lite">{{ txt.genesis.desc }}</div>
            </div>
          </div>

          <div class="building-mega-structure">
            <div class="real-platform">
              <div class="platform-surface"></div>
              <div class="platform-side"></div>
              <div class="platform-glow-lines"></div>
            </div>
            <div class="elements-cluster">
              <div class="block-card card-bnb">
                <div class="card-icon"><img src="https://cryptologos.cc/logos/binance-coin-bnb-logo.png?v=032" alt="BNB"></div>
                <div class="card-txt-group"><div class="card-label">Binance Chain</div><div class="card-sub">Infrastructure</div></div>
              </div>
              <div class="block-card card-usdt">
                <div class="card-icon"><img src="https://cryptologos.cc/logos/tether-usdt-logo.png?v=032" alt="USDT"></div>
                <div class="card-txt-group"><div class="card-label">USDT</div><div class="card-sub">Liquidity</div></div>
              </div>
              <div class="block-card card-contract">
                <div class="card-icon"><img src="https://cryptologos.cc/logos/just-jst-logo.png?v=032" alt="Contract"></div>
                <div class="card-txt-group"><div class="card-label">Smart Contract</div><div class="card-sub">Settlement</div></div>
              </div>
            </div>
          </div>
        </div>

        <div class="right-content-flow">
          <div class="side-head-pro">
            <h2 class="sec-title-pro">{{ txt.faq.title }}</h2>
            <p class="sec-desc-pro">Powered by Binance Chain Architecture</p>
          </div>
          
          <div class="faq-list-pro">
            <details class="accordion-item" open>
              <summary><span class="acc-icon">🔒</span><span class="acc-title">{{ txt.faq.q1 }}</span><span class="acc-arrow">▼</span></summary>
              <div class="acc-body"><p>{{ txt.faq.a1 }}</p></div>
            </details>
            <details class="accordion-item highlight-item">
              <summary><span class="acc-icon">⛽</span><span class="acc-title">{{ txt.faq.q2 }}</span><span class="acc-arrow">▼</span></summary>
              <div class="acc-body"><p>{{ txt.faq.a2 }}</p></div>
            </details>
            <details class="accordion-item">
              <summary><span class="acc-icon">📈</span><span class="acc-title">{{ txt.faq.q_trade }}</span><span class="acc-arrow">▼</span></summary>
              <div class="acc-body"><p>{{ txt.faq.a_trade }}</p></div>
            </details>
            <details class="accordion-item">
              <summary><span class="acc-icon">🤖</span><span class="acc-title">{{ txt.faq.q5 }}</span><span class="acc-arrow">▼</span></summary>
              <div class="acc-body"><p>{{ txt.faq.a5 }}</p></div>
            </details>
            <details class="accordion-item">
              <summary><span class="acc-icon">📝</span><span class="acc-title">{{ txt.faq.q3 }}</span><span class="acc-arrow">▼</span></summary>
              <div class="acc-body"><p>{{ txt.faq.a3 }}</p></div>
            </details>
          </div>
        </div>
      </div>
    </section>

    <section class="partners-section">
      <div class="container">
        <div class="p-title">Strategic Ecosystem Partners</div>
        <div class="marquee">
          <div class="marquee-content">
            <div class="p-item" v-for="(p,i) in partners" :key="i">
              <img :src="p.logo" :alt="p.name" @error="handleImageError($event, p)" :title="p.name">
              <span>{{ p.name }}</span>
            </div>
            <div class="p-item" v-for="(p,i) in partners" :key="'dup'+i">
              <img :src="p.logo" :alt="p.name" @error="handleImageError($event, p)" :title="p.name">
              <span>{{ p.name }}</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import DICT from '../locales/data.js';

export default {
  props: ['lang'],
  data() {
    return {
      // 3. 修改：跑马灯合作伙伴 (精选24个大厂稳定LOGO)
      partners: [
        {name:'Binance', logo:'https://cryptologos.cc/logos/binance-coin-bnb-logo.png'},
        {name:'BNB Chain', logo:'https://cryptologos.cc/logos/bnb-bnb-logo.png'},
        {name:'PancakeSwap', logo:'https://cryptologos.cc/logos/pancakeswap-cake-logo.png'},
        {name:'Trust Wallet', logo:'https://cryptologos.cc/logos/trust-wallet-token-twt-logo.png'},
        {name:'MetaMask', logo:'https://cryptologos.cc/logos/metamask-logo.png'},
        {name:'Tether', logo:'https://cryptologos.cc/logos/tether-usdt-logo.png'},
        {name:'OKX', logo:'https://cryptologos.cc/logos/okx-okb-logo.png'},
        {name:'Huobi', logo:'https://cryptologos.cc/logos/huobi-token-ht-logo.png'},
        {name:'Coinbase', logo:'https://cryptologos.cc/logos/coinbase-coin-logo.png'},
        {name:'Chainlink', logo:'https://cryptologos.cc/logos/chainlink-link-logo.png'},
        {name:'1inch', logo:'https://cryptologos.cc/logos/1inch-1inch-logo.png'},
        {name:'Aave', logo:'https://cryptologos.cc/logos/aave-aave-logo.png'},
        {name:'Uniswap', logo:'https://cryptologos.cc/logos/uniswap-uni-logo.png'},
        {name:'KuCoin', logo:'https://cryptologos.cc/logos/kucoin-token-kcs-logo.png'},
        {name:'Bitget', logo:'https://cryptologos.cc/logos/bitget-token-bgb-logo.png'},
        {name:'Gate.io', logo:'https://cryptologos.cc/logos/gate-token-gt-logo.png'},
        {name:'Ledger', logo:'https://cryptologos.cc/logos/ledger-logo.png'},
        {name:'SafePal', logo:'https://cryptologos.cc/logos/safepal-sfp-logo.png'},
        {name:'Maker', logo:'https://cryptologos.cc/logos/maker-mkr-logo.png'},
        {name:'Lido', logo:'https://cryptologos.cc/logos/lido-dao-ldo-logo.png'},
        {name:'Curve', logo:'https://cryptologos.cc/logos/curve-dao-token-crv-logo.png'},
        {name:'Axelar', logo:'https://cryptologos.cc/logos/axelar-axl-logo.png'},
        {name:'Sei', logo:'https://cryptologos.cc/logos/sei-sei-logo.png'},
        {name:'Kava', logo:'https://cryptologos.cc/logos/kava-kava-logo.png'},
        {name:'ZkSync', logo:'https://cryptologos.cc/logos/zksync-logo.png'},
        {name:'Arweave', logo:'https://cryptologos.cc/logos/arweave-ar-logo.png'},
        {name:'Render', logo:'https://cryptologos.cc/logos/render-rndr-logo.png'},
        {name:'Filecoin', logo:'https://cryptologos.cc/logos/filecoin-fil-logo.png'}
      ],
      
    }
  },
  computed: {
    txt() { return DICT[this.lang].home },
    marketList() {
      const base = DICT[this.lang].home.marketsDb || DICT['en'].home.marketsDb;
      let list = [];
      for(let i=0; i<6; i++) list.push(...base);
      return list.map((m,i) => ({...m, id: i+1}));
    }
  },
  
  mounted() {
    this.checkWalletConnection();
    // 监听钱包状态变化
    if (window.ethereum) {
      window.ethereum.on('accountsChanged', this.checkWalletConnection);
      window.ethereum.on('chainChanged', this.checkWalletConnection);
    }
  },
  
  beforeDestroy() {
    if (window.ethereum) {
      window.ethereum.removeListener('accountsChanged', this.checkWalletConnection);
      window.ethereum.removeListener('chainChanged', this.checkWalletConnection);
    }
  },
  
  methods: {
    checkWalletConnection() {
      if (window.ethereum && window.ethereum.selectedAddress) {
        this.isWalletConnected = true;
        this.walletAddress = window.ethereum.selectedAddress;
      } else {
        this.isWalletConnected = false;
        this.walletAddress = '';
      }
    },
    
    connectWallet() {
      // 触发父组件的钱包连接
      this.$emit('connect-wallet');
    },
    
    // 处理图片加载错误
    handleImageError(event, partner) {
      console.warn(`LOGO加载失败: ${partner.name}`, partner.logo);
      
      // 使用备用图片（Base64编码的简单SVG占位符）
      event.target.src = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjQwIiBoZWlnaHQ9IjQwIiByeD0iNiIgZmlsbD0iIzIyMjIyMiIvPgo8dGV4dCB4PSIyMCIgeT0iMjIiIGZvbnQtZmFtaWx5PSJBcmlhbCIgZm9udC1zaXplPSIxMiIgZmlsbD0id2hpdGUiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGRvbWluYW50LWJhc2VsaW5lPSJtaWRkbGUiPkxPR088L3RleHQ+Cjwvc3ZnPgo=';
      
      // 防止错误事件继续传播
      event.preventDefault();
    },
    
    openNodePurchase() {
      // 切换到节点购买页面
      this.$emit('switch-view', 'nodes');
    }
  }
}
</script>

<style scoped>
/* 保持原有 CSS 完全不变 */
.home-main { padding-bottom: 0; overflow-x: hidden; }

/* Hero 区域 */
.hero-section { padding: 40px 0 30px; position: relative; min-height: 600px; display: flex; flex-direction: column; overflow: hidden; }
.bg-layer { position: absolute; top: 0; left: 0; width: 100%; height: 100%; overflow: hidden; pointer-events: none; z-index: 0; }

/* 双生 LOGO */
.hero-bg-group {
  position: absolute; top: 50%; right: 15%; 
  width: 500px; 
  height: 350px;
  transform: translateY(-50%) rotate(10deg);
  pointer-events: none;
}
.binance-logo-right.main {
  position: absolute; top: 0; left: 0; width: 300px; height: 300px;
  background-image: url('https://cryptologos.cc/logos/binance-coin-bnb-logo.png?v=032');
  background-size: contain; background-repeat: no-repeat;
  opacity: 0.18;
  filter: drop-shadow(0 0 50px rgba(0,208,146,0.3));
  z-index: 2;
}
.binance-logo-right.reflect {
  position: absolute; top: 20px; left: 240px;
  width: 300px; height: 300px;
  background-image: url('https://cryptologos.cc/logos/binance-coin-bnb-logo.png?v=032');
  background-size: contain; background-repeat: no-repeat;
  opacity: 0.08;
  transform: scaleX(-1);
  filter: blur(5px);
  z-index: 1;
}

.hero-light-cast {
  position: absolute; top: 0; right: 0; width: 70%; height: 100%;
  background: radial-gradient(circle at center right, rgba(0, 208, 146, 0.2) 0%, transparent 70%);
  transform: skewX(-20deg);
  mix-blend-mode: screen;
}
.deco-dot { position: absolute; border-radius: 50%; background: #00D092; box-shadow: 0 0 10px #00D092, 0 0 20px #00D092; opacity: 0.4; }
.dd-1 { width: 8px; height: 8px; top: 30%; right: 25%; animation: float-slow 8s infinite; }
.dd-2 { width: 5px; height: 5px; top: 60%; right: 35%; animation: float-slow 12s infinite; }
.dd-3 { width: 12px; height: 12px; top: 75%; right: 15%; animation: float-slow 10s infinite; }

.hero-flex { display: flex; gap: 60px; align-items: center; position: relative; z-index: 2; width: 100%; margin-bottom: auto; }
.hero-text { flex: 1.2; max-width: 650px; }
.main-title { font-size: 64px; font-weight: 800; line-height: 1.1; margin-bottom: 24px; letter-spacing: -1px; text-shadow: 0 10px 30px rgba(0,0,0,0.5); }
.main-title ::v-deep .gradient-text { background: linear-gradient(135deg, #fff 20%, #00D092 60%, #0072ff 100%); -webkit-background-clip: text; background-clip: text; color: transparent; }
.sub-desc { color: rgba(255,255,255,0.75); font-size: 18px; line-height: 1.7; margin-bottom: 25px; max-width: 620px; font-weight: 400; }
.btn-outline { background: rgba(255,255,255,0.05); border: 1px solid rgba(255,255,255,0.2); color: #fff; padding: 14px 36px; border-radius: 30px; font-weight: 600; cursor: pointer; transition: 0.3s; font-size: 16px; }
.btn-outline:hover { background: #fff; color: #000; box-shadow: 0 0 25px rgba(255,255,255,0.2); }

.btn-primary { background: linear-gradient(135deg, #00D092, #00A878); border: none; color: #000; padding: 14px 36px; border-radius: 30px; font-weight: 700; cursor: pointer; transition: 0.3s; font-size: 16px; box-shadow: 0 10px 30px rgba(0, 208, 146, 0.3); }
.btn-primary:hover { background: linear-gradient(135deg, #00b881, #008c66); transform: translateY(-2px); box-shadow: 0 15px 40px rgba(0, 208, 146, 0.5); }
.stats-bar { display: flex; gap: 60px; border-top: 1px solid rgba(255,255,255,0.1); padding-top: 30px; }
.s-val { font-size: 32px; font-weight: 800; font-family: 'Inter', sans-serif; letter-spacing: -1px; }
.s-lbl { font-size: 12px; color: rgba(255,255,255,0.4); text-transform: uppercase; margin-top: 5px; }

/* 市场网格 */
.market-section { padding: 40px 0; background: rgba(255,255,255,0.01); }
.markets-grid-30 { display: grid; grid-template-columns: repeat(auto-fill, minmax(240px, 1fr)); gap: 15px; margin-bottom: 30px; }
.m-head { font-weight: 700; color: rgba(255,255,255,0.5); font-size: 12px; letter-spacing: 1px; text-transform: uppercase; }
.market-card { background: rgba(20, 21, 26, 0.6); border: 1px solid rgba(255,255,255,0.08); padding: 20px; border-radius: 12px; transition: 0.3s; cursor: pointer; }
.market-card:hover { transform: translateY(-3px); border-color: rgba(0,208,146,0.3); }
.mc-title { margin: 0 0 10px 0; font-size: 14px; font-weight: 600; line-height: 1.4; color: rgba(255,255,255,0.95); height: 40px; overflow: hidden; }
.prob-bar { flex: 1; height: 4px; background: rgba(255,255,255,0.1); border-radius: 2px; overflow: hidden; }
.fill { height: 100%; }
.trade-btn { width: 100%; border: none; padding: 8px; border-radius: 6px; font-weight: 700; cursor: pointer; color: #000; font-size: 12px; opacity: 0.9; transition: 0.2s; }
.trade-btn:hover { opacity: 1; transform: scale(1.05); }
.mc-top { display: flex; justify-content: space-between; font-size: 10px; margin-bottom: 10px; }
.mc-prob { display: flex; align-items: center; gap: 8px; font-size: 12px; color: #ccc; margin-bottom: 15px; }
.load-more-wrap { text-align: center; }
.load-more-btn { background: transparent; border: 1px solid rgba(255,255,255,0.2); color: #fff; padding: 10px 30px; border-radius: 20px; cursor: pointer; transition: 0.3s; font-size: 13px; }
.load-more-btn:hover { background: rgba(255,255,255,0.1); border-color: #fff; }

/* INFRA SECTION */
.infra-section-redesigned {
  position: relative; padding: 80px 0 120px;
  background: linear-gradient(180deg, #08090c 0%, #0a0b10 100%);
  overflow: hidden;
}
.ambient-glow { position: absolute; top: 50%; right: 0; width: 50%; height: 50%; background: radial-gradient(circle at center, rgba(0, 208, 146, 0.08), transparent 60%); transform: translateY(-50%); pointer-events: none; }
.split-layout-pro { display: flex; gap: 80px; align-items: flex-start; position: relative; z-index: 2; }

/* 左侧 */
.left-visual-anchor { flex: 1.3; display: flex; flex-direction: column; align-items: center; perspective: 1200px; position: sticky; top: 100px; }

/* 创世挖矿卡片 */
.genesis-card-lite {
  width: 100%; max-width: 550px;
  background: linear-gradient(135deg, rgba(30, 30, 35, 0.9), rgba(20, 20, 25, 0.95));
  border: 1px solid rgba(255, 215, 0, 0.25);
  border-radius: 16px;
  padding: 20px 25px;
  display: flex; align-items: center; gap: 20px;
  margin-bottom: 40px;
  backdrop-filter: blur(10px);
  box-shadow: 0 15px 40px rgba(0,0,0,0.4);
  animation: float-card 6s ease-in-out infinite;
}
.gc-icon-box { font-size: 28px; background: rgba(255, 215, 0, 0.1); width: 50px; height: 50px; display: flex; align-items: center; justify-content: center; border-radius: 12px; }
.gc-info-lite { flex: 1; }
.gc-title-lite { font-weight: 800; color: #fff; font-size: 17px; margin-bottom: 6px; display: flex; align-items: center; gap: 10px; }
.live-tag { background: #FFD700; color: #000; font-size: 10px; padding: 3px 7px; border-radius: 6px; font-weight: 800; letter-spacing: 1px; box-shadow: 0 0 10px rgba(255, 215, 0, 0.4); }
.gc-desc-lite { color: rgba(255,255,255,0.65); font-size: 13px; line-height: 1.5; }

/* 3D 建筑 */
.building-mega-structure { position: relative; width: 600px; height: 500px; display: flex; justify-content: center; align-items: flex-end; }
.real-platform { position: absolute; bottom: 0; width: 100%; height: 250px; transform: rotateX(60deg); transform-style: preserve-3d; }
.platform-surface { position: absolute; width: 100%; height: 100%; background: linear-gradient(to bottom, #1a1b20, #0a0b10); border: 1px solid rgba(0,208,146,0.3); box-shadow: 0 0 80px rgba(0,208,146,0.15); }
.platform-side { position: absolute; bottom: -25px; width: 100%; height: 25px; background: #050608; transform: rotateX(-90deg); transform-origin: top; border-bottom: 2px solid rgba(0,208,146,0.5); }
.platform-glow-lines { position: absolute; inset: 0; background-image: linear-gradient(0deg, transparent 24%, rgba(0,208,146,.2) 25%, transparent 26%), linear-gradient(90deg, transparent 24%, rgba(0,208,146,.2) 25%, transparent 26%); background-size: 50px 50px; }
.elements-cluster { display: flex; gap: 20px; transform: translateZ(60px); padding-bottom: 40px; }
.block-card { flex: 1; width: 140px; background: linear-gradient(180deg, rgba(20,20,25,0.9), rgba(10,10,12,0.95)); border: 1px solid rgba(255,255,255,0.1); border-bottom: 4px solid #00D092; border-radius: 12px 12px 4px 4px; padding: 30px 10px; text-align: center; transition: 0.3s; box-shadow: 0 20px 40px rgba(0,0,0,0.5); display: flex; flex-direction: column; align-items: center; justify-content: flex-end; }
.card-trx { height: 220px; transform: translateZ(40px) rotateY(-10deg); }
.card-usdt { height: 280px; transform: translateZ(60px) scale(1.05); border-bottom-color: #009393; z-index: 2; background: linear-gradient(180deg, rgba(30,35,40,0.95), rgba(10,10,12,0.95)); }
.card-contract { height: 200px; transform: translateZ(30px) rotateY(10deg); border-bottom-color: #9b59b6; }
.block-card:hover { transform: translateY(-10px) scale(1.05); }
.card-icon img { width: 50px; height: 50px; margin-bottom: 20px; }
.card-label { font-size: 14px; font-weight: 700; color: #fff; margin-bottom: 5px; }
.card-sub { font-size: 10px; color: rgba(255,255,255,0.4); text-transform: uppercase; }

/* 右侧：FAQ */
.right-content-flow { flex: 1; padding-left: 20px; display: flex; flex-direction: column; justify-content: center; }
.sec-title-pro { font-size: 36px; margin-bottom: 10px; font-weight: 800; background: linear-gradient(to right, #fff, #aaa); -webkit-background-clip: text; background-clip: text; color: transparent; }
.sec-desc-pro { font-size: 14px; color: #00D092; text-transform: uppercase; letter-spacing: 2px; font-weight: bold; margin-bottom: 30px; }
.faq-list-pro { display: flex; flex-direction: column; gap: 15px; }
.accordion-item { background: rgba(255,255,255,0.02); border: 1px solid rgba(255,255,255,0.08); border-radius: 12px; overflow: hidden; transition: 0.3s; }
.accordion-item:hover { border-color: rgba(0,208,146,0.3); background: rgba(255,255,255,0.04); }
.accordion-item summary { padding: 18px 22px; cursor: pointer; display: flex; align-items: center; justify-content: space-between; list-style: none; outline: none; }
.accordion-item[open] { background: rgba(0,208,146,0.04); border-color: #00D092; }
.acc-icon { font-size: 18px; margin-right: 15px; color: #00D092; }
.acc-title { font-size: 15px; font-weight: 700; color: #fff; flex: 1; }
.acc-body { padding: 0 22px 22px 55px; color: rgba(255,255,255,0.65); font-size: 13px; line-height: 1.7; animation: slideDown 0.3s ease; }

/* 跑马灯 */
.partners-section { padding: 60px 0; text-align: center; overflow: hidden; background: #08090c; border-top: 1px solid rgba(255,255,255,0.05); position: relative; z-index: 10; }
.marquee-content { display: inline-block; animation: scroll 40s linear infinite; display: flex; align-items: center; gap: 50px; }
.p-item { display: flex; align-items: center; gap: 10px; opacity: 0.5; transition: 0.3s; filter: grayscale(100%); }
.p-item:hover { opacity: 1; filter: grayscale(0%); }
.p-item img { height: 26px; width: auto; filter: none; }
.p-item span { font-size: 14px; font-weight: 600; }

@keyframes scroll { 0% {transform: translateX(0)} 100% {transform: translateX(-50%)} }
@keyframes float { 0%,100% {transform: translateY(-50%) rotate(-10deg) translateY(0px);} 50% {transform: translateY(-50%) rotate(-10deg) translateY(-20px);} }
@keyframes float-card { 0%,100% {transform: translateY(0);} 50% {transform: translateY(-8px);} }
@keyframes float-slow { 0%,100% {transform: translateY(0);} 50% {transform: translateY(-15px);} }

/* 响应式 (手机端隐藏右侧LOGO) */
@media (max-width: 960px) {
  .hero-flex { flex-direction: column; text-align: center; }
  .hero-text { max-width: 100%; }
  .markets-grid-30 { grid-template-columns: 1fr; }
  .hero-btns, .stats-bar { justify-content: center; }
  .main-title { font-size: 42px; }
  .hero-bg-group, .deco-dot { display: none; } /* 手机端隐藏背景大LOGO */
  
  .split-layout-pro { flex-direction: column; gap: 50px; }
  .left-visual-anchor { order: 1; width: 100%; transform: scale(0.7); transform-origin: top center; margin-bottom: -150px; position: static; }
  .genesis-card-lite { width: 90%; margin-bottom: 30px; }
  
  .right-content-flow { padding: 0 20px; order: 0; width: 100%; box-sizing: border-box; }
  .sec-title-pro { font-size: 28px; text-align: center; }
  .sec-desc-pro { text-align: center; margin-bottom: 25px; }
  .accordion-item summary { text-align: left; }
  .acc-body { padding: 0 20px 20px 20px; text-align: left; }
}

/* 节点购买部分样式 */
.nodes-section {
  padding: 80px 0;
  background: linear-gradient(180deg, #0a0b10 0%, #08090c 100%);
  position: relative;
  overflow: hidden;
}

.nodes-section::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 1px;
  background: linear-gradient(90deg, transparent, #00D092, transparent);
}

.section-header {
  text-align: center;
  margin-bottom: 50px;
}

.section-title {
  font-size: 42px;
  font-weight: 800;
  background: linear-gradient(to right, #00D092, #00A878);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  margin-bottom: 15px;
}

.section-subtitle {
  font-size: 16px;
  color: rgba(255, 255, 255, 0.7);
  max-width: 600px;
  margin: 0 auto;
  line-height: 1.6;
}

.nodes-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 25px;
  margin-bottom: 40px;
}

.node-card {
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 16px;
  padding: 25px;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.node-card:hover {
  transform: translateY(-5px);
  border-color: rgba(0, 208, 146, 0.3);
  box-shadow: 0 10px 30px rgba(0, 208, 146, 0.1);
}

.node-card.coming-soon {
  opacity: 0.7;
  filter: grayscale(0.3);
}

.node-card.coming-soon:hover {
  transform: none;
  border-color: rgba(255, 255, 255, 0.08);
  box-shadow: none;
}

.node-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 20px;
}

.node-icon {
  font-size: 40px;
  line-height: 1;
}

.node-badge {
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.badge-whitelist {
  background: rgba(255, 215, 0, 0.15);
  color: #FFD700;
  border: 1px solid rgba(255, 215, 0, 0.3);
}

.badge-small {
  background: rgba(0, 208, 146, 0.15);
  color: #00D092;
  border: 1px solid rgba(0, 208, 146, 0.3);
}

.badge-medium {
  background: rgba(66, 133, 244, 0.15);
  color: #4285F4;
  border: 1px solid rgba(66, 133, 244, 0.3);
}

.badge-large {
  background: rgba(255, 109, 0, 0.15);
  color: #FF6D00;
  border: 1px solid rgba(255, 109, 0, 0.3);
}

.badge-super {
  background: rgba(156, 39, 176, 0.15);
  color: #9C27B0;
  border: 1px solid rgba(156, 39, 176, 0.3);
}

.node-content {
  margin-bottom: 25px;
}

.node-title {
  font-size: 22px;
  font-weight: 700;
  color: #fff;
  margin-bottom: 15px;
}

.node-price {
  display: flex;
  align-items: baseline;
  margin-bottom: 20px;
}

.price-amount {
  font-size: 36px;
  font-weight: 800;
  color: #00D092;
  margin-right: 8px;
}

.price-unit {
  font-size: 16px;
  color: rgba(255, 255, 255, 0.6);
  font-weight: 600;
}

.node-features {
  list-style: none;
  padding: 0;
  margin: 0;
}

.node-features li {
  color: rgba(255, 255, 255, 0.7);
  font-size: 14px;
  line-height: 1.6;
  margin-bottom: 10px;
  padding-left: 20px;
  position: relative;
}

.node-features li::before {
  content: '✓';
  position: absolute;
  left: 0;
  color: #00D092;
  font-weight: bold;
}

.node-footer {
  margin-top: auto;
}

.node-buy-btn {
  width: 100%;
  padding: 16px;
  background: linear-gradient(135deg, #00D092, #00A878);
  color: white;
  border: none;
  border-radius: 12px;
  font-size: 16px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.3s ease;
}

.node-buy-btn:hover {
  background: linear-gradient(135deg, #00A878, #008C68);
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(0, 208, 146, 0.3);
}

.node-buy-btn.btn-disabled {
  background: linear-gradient(135deg, #666, #444);
  cursor: not-allowed;
  opacity: 0.7;
}

.node-buy-btn.btn-disabled:hover {
  transform: none;
  box-shadow: none;
  background: linear-gradient(135deg, #666, #444);
}

.node-coming-soon {
  text-align: center;
  padding: 16px;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 12px;
  border: 1px dashed rgba(255, 255, 255, 0.2);
}

.coming-soon-text {
  display: block;
  font-size: 16px;
  font-weight: 700;
  color: rgba(255, 255, 255, 0.5);
  margin-bottom: 5px;
}

.coming-soon-desc {
  display: block;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.4);
}

.nodes-info {
  text-align: center;
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;
  background: rgba(0, 208, 146, 0.05);
  border-radius: 12px;
  border: 1px solid rgba(0, 208, 146, 0.1);
}

.info-text {
  color: rgba(255, 255, 255, 0.7);
  font-size: 14px;
  line-height: 1.6;
  margin: 0;
}

/* 响应式调整 */
@media (max-width: 960px) {
  .nodes-section {
    padding: 60px 20px;
  }
  
  .section-title {
    font-size: 32px;
  }
  
  .nodes-grid {
    grid-template-columns: 1fr;
    max-width: 400px;
    margin: 0 auto 40px;
  }
  
  .node-card {
    padding: 20px;
  }
  
  .price-amount {
    font-size: 32px;
  }
}
</style>